// Module
var code = "<venue-view data=$ctrl.data similar-venues=$ctrl.similarVenues search-params=$ctrl.searchParams is-bot=$ctrl.isBot ng-if=$ctrl.data redirect=$ctrl.redirect(url)></venue-view>";
// Exports
module.exports = code;